import styled, { css } from 'styled-components'

import * as S from '../../../../../../components/TableComponents/style'

export const TableBodyRow = styled(S.TBodyTR)`
  cursor: pointer;
  ${({ clicked }) =>
    clicked &&
    css`
      background-color: #ff1744 !important;
      color: #ffffff;
    `};
`
